module.exports = __webpack_public_path__ + "img/60.2029a623.jpg";